import { Link } from 'react-router-dom';
import { StoreIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import {
    Dialog,
    DialogBody,
    DialogTitle,
    ScrollDialogContent,
    ScrollDialogFooter,
    ScrollDialogHeader,
} from '@/components/ui/dialog-scroll';
import { Spinner } from '@/components/ui/spinner';
import { useFetch } from '@/hooks/useFecth';
import useDialog from '@/hooks/useDialog';
import ClubEmptyList from './ClubEmptyList';
import ClubSettingsCardHeader from './ClubSettingsCardHeader';

export default function ResaleProductsClub() {
    const { data, error, isLoading } = useFetch('club/resale-products');
    const { open, handleClose } = useDialog('#resale-products');
    const count = data?.length ?? 0;

    return (
        <>
            <Card>
                <CardHeader>
                    <ClubSettingsCardHeader
                        icon={StoreIcon}
                        title="Produtos de revenda"
                        description="Visualize e gerencie os produtos de revenda do seu clube."
                    />
                </CardHeader>
                <CardContent className="space-y-1 text-sm">
                    <span className="text-muted-foreground">Disponíveis</span>
                    <p className="font-medium">
                        {count === 0 ? 'Nenhum produto' : `${count} produto${count !== 1 ? 's' : ''}`}
                    </p>
                </CardContent>
                <CardFooter>
                    <Button variant="outline" size="sm" render={<Link to="#resale-products" />}>
                        Ver produtos
                    </Button>
                </CardFooter>
            </Card>

            <Dialog open={open} onOpenChange={isOpen => !isOpen && handleClose()}>
                <ScrollDialogContent className="sm:max-w-2xl">
                    <ScrollDialogHeader>
                        <DialogTitle>Produtos de revenda</DialogTitle>
                    </ScrollDialogHeader>
                    <DialogBody>
                        <Card>
                            <CardContent className="p-0">
                                {isLoading ? (
                                    <div className="flex justify-center py-10">
                                        <Spinner className="size-6" />
                                    </div>
                                ) : error ? (
                                    <p className="px-4 py-8 text-center text-sm text-destructive">
                                        Erro ao carregar produtos de revenda.
                                    </p>
                                ) : !data?.length ? (
                                    <ClubEmptyList
                                        title="Nenhum produto de revenda encontrado"
                                        description="Os produtos disponíveis para revenda aparecerão aqui."
                                    />
                                ) : (
                                    <div className="divide-y">
                                        {data.map(item => (
                                            <div key={item.id} className="p-4">
                                                <p className="font-medium">{item.name}</p>
                                                <p className="text-sm text-muted-foreground">{item.Product?.description}</p>
                                                <p className="mt-1 text-xs text-muted-foreground">
                                                    Tipo: {item.type} | Custo: R${' '}
                                                    {Number(item.price).toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                    })}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </CardContent>
                        </Card>
                    </DialogBody>
                    <ScrollDialogFooter>
                        <Button variant="outline" onClick={handleClose}>
                            Fechar
                        </Button>
                    </ScrollDialogFooter>
                </ScrollDialogContent>
            </Dialog>
        </>
    );
}
